import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useLanguage } from '../context/LanguageContext';

export const useCountries = () => {
    const [countries, setCountries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { language } = useLanguage();

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await axios.get('https://admin.baicoman.com/api/fetch-countries');
                if (response.data && response.data.success) {
                    setCountries(response.data.data);
                } else {
                    setError('Failed to fetch countries');
                }
            } catch (err) {
                console.error("Error fetching countries:", err);
                setError(err.message || 'An error occurred');
            } finally {
                setLoading(false);
            }
        };

        fetchCountries();
    }, []);

    // Helper to get phone code for a selected country ID
    const getPhoneCode = useCallback((countryId) => {
        const country = countries.find(c => String(c.id) === String(countryId));
        return country ? country.phone_prefix : '';
    }, [countries]);

    return { countries, loading, error, getPhoneCode };
};
